import { Alert, Button, FloatingLabel, Form, Modal } from 'react-bootstrap'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { useCollectOrderTestMutation } from '../generated/urql.lab-user'

export type CollectOrderTestModalType = {
  show: (orderTestId: number, tubeCode?: string | null) => void
}

const CollectOrderTestModal = forwardRef<
  CollectOrderTestModalType,
  {
    onChange: () => void
  }
>(({ onChange }, ref) => {
  const [show, setShow] = useState(false)
  const [orderTestId, setOrderTestId] = useState<number>()
  const [tubeCode, setTubeCode] = useState<string>('')
  const [, collectOrderTest] = useCollectOrderTestMutation()
  const [generalError, setGeneralError] = useState<string>()

  useImperativeHandle(ref, () => ({
    show: (id, tubeCodeValue) => {
      setOrderTestId(id)
      setTubeCode(tubeCodeValue || '')
      setGeneralError(undefined)
      setShow(true)
    },
  }))

  const handleSubmit = async () => {
    if (!orderTestId) {
      setGeneralError('Missing orderTestId')
      return
    }

    setGeneralError(undefined)

    const { error } = await collectOrderTest({
      id: orderTestId,
      tubeCode: tubeCode || null,
      collectedOn: new Date().toISOString(),
    })

    if (
      error?.graphQLErrors.find(err =>
        (err.extensions.internal as any)?.error?.message?.includes(
          'is already used by a different order',
        ),
      )
    ) {
      setGeneralError('Próbka o podanym kodzie już istnieje')
      return
    }

    if (error) {
      setGeneralError(error.message)
      return
    }

    setShow(false)
    onChange()
  }

  return (
    <Modal
      show={show}
      onHide={() => {
        setShow(false)
        setTubeCode('')
        setOrderTestId(undefined)
        setGeneralError(undefined)
      }}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Kod probówki</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {generalError && <Alert variant="danger">{generalError}</Alert>}
        <FloatingLabel
          controlId="tubeCodeInput"
          label="Kod probówki"
          className="mb-3"
        >
          <Form.Control
            type="text"
            placeholder="Kod probówki"
            value={tubeCode}
            onChange={(event) => setTubeCode(event.target.value)}
            autoFocus
          />
        </FloatingLabel>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setShow(false)
          }}
        >
          Anuluj
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Zapisz
        </Button>
      </Modal.Footer>
    </Modal>
  )
})

export default CollectOrderTestModal

